var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExrd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.372 27.527c-.628 0-7.372-9.097-7.798-9.097H1v-2.383c1.552-.072 4.874-.173 5.74 0 .457.091 4.76 5.848 5.632 5.848C13.006 21.895 20 5 20.602 5H31v2.816c-2.238-.145-7.067 0-8.664 0-.836 0-9.336 19.711-9.964 19.711z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExrd);
export default __webpack_public_path__ + "static/media/EXRD.8a3f59745705bfdecb45710e56d1bbb3.svg";
export { ForwardRef as ReactComponent };